import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import ProfSearch from '../components/ProfSearch.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        let findBackground = this.el.dataset.background;
        let canChangeUrl = this.el.dataset.canchangeurl;
        let target = this.el.dataset.target;
        let onlyProf = this.el.dataset.prof;
        if (onlyProf != '1') {
            onlyProf = 0
        }

        const app = createApp({
            template: '<ProfSearch background="'+findBackground+'" prof="'+onlyProf+'" canChangeUrl="'+canChangeUrl+'" target="'+target+'" />',
            components: {
                ProfSearch
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        app.mount(self.el)
    }
}